import React, { FC } from 'react';
import './HoldingsReallocatedStatement.scss';

type Props = {};

const HoldingsReallocatedStatement: FC<Props> = () => (
  <div className="disclaimer">
    The underlying holdings of the T. Rowe Price mutual funds, to the extent
    possible, have been reallocated into the appropriate category. Figures may
    not total to 100% due to rounding.
  </div>
);

export default HoldingsReallocatedStatement;
